import React from 'react';

import { type CreateCustomRoleRequest } from '@column/api';
import { Input } from '@column/ui';

import { RenderFields } from '~/components';

type RoleInfoFields = Pick<CreateCustomRoleRequest, 'name' | 'description'>;

export const RoleInfo: React.FC = () => {
  return RenderFields<RoleInfoFields>({
    sections: [
      {
        fields: [
          {
            id: 'name',
            defaultValue: '',
            label: 'Role Name',
            rules: { required: true },
            children: ({ value, onChange, onBlur, ref }, { error }) => (
              <Input
                ref={ref}
                placeholder="Role name"
                aria-invalid={!!error}
                value={String(value ?? '')}
                onChange={onChange}
                onBlur={onBlur}
              />
            ),
          },
          {
            id: 'description',
            defaultValue: '',
            label: 'Role Description',
            description: 'Describe the use of the role and summarize its permissions',
            children: ({ value, onChange, onBlur, ref }, { error }) => (
              <Input
                ref={ref}
                placeholder="Role description"
                aria-invalid={!!error}
                value={String(value ?? '')}
                onChange={onChange}
                onBlur={onBlur}
              />
            ),
          },
        ],
      },
    ],
  });
};
